
<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-tabs v-model="activeKey" @change="changeTab">
        <a-tab-pane v-for="item in tabList" :key="item.key" :tab="$t(item.title)">
          <a-table
              ref="table"
              size="middle"
              :scroll="{y:'calc(60vh - 120px)'}"
              :pagination="ipagination"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
            </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </j-modal>
</template>

<script>

  import { getAction } from '@/api/manage'
  import {isNull} from '@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeterIntervalAndSenseRecordModal',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("操作"),
        model: {},
        confirmLoading: false,
        bodyStyle: {
          height: '70vh',
          'overflow-y': 'hidden'
        },
        visible: false,
        url: {
          queryIntervalDataByMeterId: "/jeecg-charge/meter/meterUpDataInterval/list",
          querySenseDataByMeterId: "/jeecg-charge/meter/meterUpDataSense/list"
        },
        activeKey: 1,
        tabList: [
        ],
        loading: false,
        dataSource: [],
        disableMixinCreated: true,
        /* 排序参数 */
        isorter:{
          column: 'meterDateTime',
          order: 'desc',
        },
      }
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          }, {
            title: this.$t('时间'),
            align: "center",
            dataIndex: 'meterDateTime'
          }, {
            title: this.$t('流量(m³)'),
            align: "center",
            dataIndex: 'meterDataValue',
            customRender: (t, r, index) => {
              if (t < 0) {
                return this.$t('无数据')
              }
              return (t / 1000).toFixed(2);
            }
          }
        ]
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(record.dataType == 1) {
            // 间隔流量
            this.tabList = [
            {key: 1,title: this.$t('间隔流量')}
        ]
        }else if(record.dataType == 2){
            this.activeKey = 2
            //密集数据
            this.tabList = [
                {key: 2,title: this.$t('密集流量')}
            ]
        }else {
            this.tabList = [
                {key: 1,title: this.$t('间隔流量')},
                {key: 2,title: this.$t('密集流量')}
            ]
        }
        this.visible = true;
        this.loadData(1);
      },
      changeTab() {
        // 切换tab
        this.loadData(1)
      },
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.dataSource = [];
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      loadData(arg) {
          // 查询密集流量
         //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        params.meterId = this.model.meterId;
        let url = this.url.queryIntervalDataByMeterId;
        if(this.activeKey === 2) {
            url = this.url.querySenseDataByMeterId;
        }
        this.loading = true;
        getAction(url, params).then((res) => {
            if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            }
            if(res.code===510){
            this.$message.warning(res.message)
            }
            this.loading = false;
        })
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>